import React from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import styled from 'styled-components'
import { UTM_CONTENT } from './constants'
import { sendWidgetClick } from '../../utils/ga4Events'
import { getLinkTarget } from '../../utils/getLinkTarget'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`

const Logo = styled.img`
  width: 40px;
  margin-right: 16px;
`

const Description = styled.span`
  font-size: 14px;
  line-height: 18px;
`

const Button = styled.a`
  width: 100%;
  height: 44px;
  text-align: center;
  background: ${props => props.theme.button.background};
  border: 1px solid ${props => props.theme.button.border};
  border-radius: 3px;
  color: ${props => props.theme.button.color};
  font-size: 15px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 9px 0;

  &:hover {
    background: ${props => props.theme.button.hover.background};
    border-color: ${props => props.theme.button.hover.border};
    color: ${props => props.theme.button.color};
    text-decoration: none;
  }
`

export const PujduOrganic = (props) => {
  const {
    activeDynamicLayout,
    googleAnalytics,
    utmMedium,
    widget,
    widget: {
      meta: {
        description,
        button: {
          text: buttonText,
          location
        }
      }
    }
  } = props

  const utmTitleLink = utmLinkGenerator.createLink(location, { utmMedium, utmContent: UTM_CONTENT.title })
  const utmButtonLink = utmLinkGenerator.createLink(location, { utmMedium, utmContent: UTM_CONTENT.button })

  const handleClick = (location) => {
    sendWidgetClick({
      name: 'pujdu-a',
      click: {
        type: 'link',
        position: 8,
        location
      }
    })
  }

  return (
    <WidgetContainer
      widget={widget}
      googleAnalytics={googleAnalytics}
      showBottomLine={false}
      overrideHeadlineLink={utmTitleLink}
      activeDynamicLayout={activeDynamicLayout}
    >
      <Wrapper>
        <Row>
          <Logo src={`${STATICS_PATH}images/pujdu/pujdu-logo.svg`}/>
          <Description>{description}</Description>
        </Row>
        <Button onClick={handleClick} href={utmButtonLink} target={getLinkTarget(activeDynamicLayout)}>{buttonText}</Button>
      </Wrapper>
    </WidgetContainer>
  )
}
